import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "card modern-card" }
const _hoisted_3 = { class: "card-header text-center" }
const _hoisted_4 = {
  key: 0,
  class: "fas fa-check-circle fa-3x text-white mb-3"
}
const _hoisted_5 = {
  key: 1,
  class: "fas fa-times-circle fa-3x text-white mb-3"
}
const _hoisted_6 = {
  key: 2,
  class: "fas fa-spinner fa-spin fa-3x text-white mb-3"
}
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "card-body p-4" }
const _hoisted_9 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_10 = {
  key: 1,
  class: "success-content"
}
const _hoisted_11 = { class: "payment-details" }
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = { class: "detail-value" }
const _hoisted_14 = { class: "detail-row" }
const _hoisted_15 = { class: "badge bg-warning" }
const _hoisted_16 = { class: "detail-row" }
const _hoisted_17 = { class: "detail-value text-capitalize" }
const _hoisted_18 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_19 = { class: "detail-value" }
const _hoisted_20 = { class: "action-buttons mt-4" }
const _hoisted_21 = {
  key: 2,
  class: "error-content"
}
const _hoisted_22 = { class: "alert alert-danger" }
const _hoisted_23 = { class: "text-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.verificationStatus === 'success')
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : (_ctx.verificationStatus === 'error')
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : (_openBlock(), _createElementBlock("i", _hoisted_6)),
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.verificationStatus === 'success' ? ' Paiement réussi !' : 
             _ctx.verificationStatus === 'error' ? ' Erreur de paiement' : 
             ' Vérification en cours...'), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "spinner-border text-primary mb-3" }, null, -1),
              _createElementVNode("p", { class: "text-muted" }, "Vérification du paiement et mise à jour du statut...", -1)
            ]))]))
          : (_ctx.verificationStatus === 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "alert alert-success d-flex align-items-center mb-4" }, [
                  _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, "Votre paiement a été confirmé avec succès !"),
                    _createElementVNode("br"),
                    _createTextVNode(" Votre dossier BESC est maintenant en attente de validation par le Conseil des Chargeurs. ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "mb-3" }, "Détails de la transaction", -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "detail-label" }, "Référence BESC", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.refbesc), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "detail-label" }, "Statut du dossier", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.bescStatus), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "detail-label" }, "Méthode de paiement", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.paymentMethod), 1)
                  ]),
                  (_ctx.transactionId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "detail-label" }, "ID Transaction", -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.transactionId), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printReceipt && _ctx.printReceipt(...args))),
                    class: "btn btn-outline-primary me-2"
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "fas fa-print me-2" }, null, -1),
                    _createTextVNode(" Imprimer le reçu ", -1)
                  ]))]),
                  _createVNode(_component_router_link, {
                    to: "/liste-besc",
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "fas fa-list me-2" }, null, -1),
                      _createTextVNode(" Retour à la liste ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
            : (_ctx.verificationStatus === 'error')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Erreur :", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      to: "/liste-besc",
                      class: "btn btn-secondary"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1),
                        _createTextVNode(" Retour à la liste ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}